export const typeCollectionMap = {
  'app': 'apps',
  'domain': 'domains',
  'ctv': 'ctv',
  'apps' : 'apps',
  'domains' : 'domains'
};
